/**
 * LinkedIn Import Bridge
 * Handles communication between the LinkedIn Importer extension and the ATS application
 */

const ALLOWED_ORIGIN = window.location.origin;

export function isValidATSMessage(data) {
	if (!data || typeof data !== 'object') return false;

	if (data.type !== 'ATS_IMPORT') return false;
	if (typeof data.nonce !== 'string') return false;
	if (!data.payload || typeof data.payload !== 'object') return false;

	const payload = data.payload;

	if (typeof payload.name !== 'string') return false;
	if (typeof payload.profileUrl !== 'string') return false;
	if (typeof payload.extractedAt !== 'string') return false;
	if (payload.source !== 'linkedin_public_profile') return false;

	return true;
}

export function createImportListener(options) {
	const { expectedNonce, onImport, onError } = options;

	function handleMessage(event) {
		if (event.origin !== ALLOWED_ORIGIN) {
			return;
		}

		if (!isValidATSMessage(event.data)) {
			return;
		}

		const message = event.data;

		if (expectedNonce && message.nonce !== expectedNonce) {
			onError?.('Invalid security token. Please try importing again.');
			return;
		}

		onImport(message.payload);
	}

	window.addEventListener('message', handleMessage);

	return () => {
		window.removeEventListener('message', handleMessage);
	};
}

export function extractNonceFromUrl() {
	const hash = window.location.hash;
	const params = new URLSearchParams(
		hash.includes('?') ? hash.split('?')[1] : ''
	);
	return params.get('nonce');
}

export function isLinkedInImportSource() {
	const hash = window.location.hash;
	const params = new URLSearchParams(
		hash.includes('?') ? hash.split('?')[1] : ''
	);
	return params.get('source') === 'linkedin-ext';
}

export function mapLinkedInProfileToApplicant(profile) {
	return {
		name: profile.name || '',
		email: profile.email || '',
		phoneNumber: profile.phone || '',
		city: profile.city || '',
		linkedinUrl: profile.profileUrl || null,
		countryName: profile.country || '',
		headline: profile.headline || '',
		currentCompany: profile.currentCompany || '',
		location: profile.location || '',
		profileImageUrl: profile.imageUrl || null,
		// Metadata
		importedFrom: 'linkedin',
		importedAt: profile.extractedAt
	};
}

export function getHashParams() {
	const hash = window.location.hash;
	return new URLSearchParams(hash.includes('?') ? hash.split('?')[1] : '');
}
